import { IsFocusVisibleClassName } from '@fluentui/react';

/**
 * Returns whether or not the user is currently navigating the app by keyboard
 * @returns Boolean
 */
export const isKeyboardNavigation = (): boolean => {
  return document.body.classList.contains(IsFocusVisibleClassName);
};
